import * as React from 'react';
import { ReactStripeElements } from 'react-stripe-elements';

import BankCard from 'components/BankCard';
import CoachingBillingDetailDeclinedCard from 'coaching/components/CoachingBillingView/CoachingBillingDetailDeclinedCard';
import CoachingBillingCardSidebar from 'coaching/components/CoachingBillingView/CoachingBillingCardSidebar';
import { useCoachingViewState } from 'coaching/components/CoachingView';

import { CoachingBillingCard } from './types';

export default function CoachingBillingDetailCard(
  props: CoachingBillingCard & ReactStripeElements.InjectedStripeProps
) {
  const { cardDetail, onRetryPaymentMethod, stripe } = props;
  const { setSidebarIsOpen, setSidebar } = useCoachingViewState();

  const onUpdateBankCard = () => {
    setSidebar(
      <CoachingBillingCardSidebar cardDetail={cardDetail} onClose={() => setSidebarIsOpen(false)} />
    );
    setSidebarIsOpen(true);
  };

  return (
    <BankCard
      onUpdateBankCard={onUpdateBankCard}
      onAddBankCard={onUpdateBankCard}
      data-test="coaching-billing-card"
      brand={cardDetail?.info?.brand}
      lastFour={cardDetail?.info?.lastFour}>
      <CoachingBillingDetailDeclinedCard
        data-test={'coaching-billing-declined-card'}
        detail={cardDetail?.declinedInfo}
        onRetryPaymentMethod={onRetryPaymentMethod}
      />
    </BankCard>
  );
}
